/**
 * Dictionary limits the API enforces (validators and dictionary_service) and
 * every client mirrors in its own UI. Defined here once so the two cannot drift.
 */

/** Terms one dictionary can hold. */
export const MAX_DICTIONARY_ENTRIES = 300

/** Characters in one term. */
export const MAX_DICTIONARY_TERM_LENGTH = 80

/** Characters in a dictionary's name. */
export const MAX_DICTIONARY_NAME_LENGTH = 80
